module.exports = __webpack_public_path__ + "static/media/wedding8.0b13d483.jpg";